"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

/* eslint-disable max-len */
var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  stroke: "currentColor",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  height: "14",
  width: "14",
  viewBox: "0 0 21.56 23.47"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "bar-graph",
  fill: "currentColor",
  d: "m20.22,15.22h-2.7c-.74,0-1.35.6-1.35,1.35h0v6.9h5.39v-6.9c0-.74-.6-1.35-1.34-1.35Zm-8.09-5.22h-2.7c-.74,0-1.35.6-1.35,1.35,0,0,0,0,0,0v12.12h5.39v-12.12c0-.74-.6-1.35-1.34-1.35Zm-8.09,9.43H1.34c-.74,0-1.34.6-1.34,1.35v2.68h5.39v-2.68c0-.74-.6-1.35-1.34-1.35,0,0,0,0,0,0Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_26233",
  fill: "currentColor",
  d: "m8.22,7.97c.12-.72.24-1.41.36-2.09.04-.21.06-.43.11-.64.03-.11-.01-.22-.1-.29-.6-.58-1.2-1.15-1.79-1.74-.05-.05-.1-.1-.17-.18.34-.05.65-.1.96-.15.6-.09,1.2-.17,1.8-.26.09-.03.16-.09.2-.18.37-.74.74-1.48,1.1-2.23.03-.07.07-.13.12-.22.05.09.09.15.12.22.37.74.74,1.49,1.1,2.23.04.11.15.18.26.19.89.12,1.77.26,2.7.39-.06.07-.1.12-.15.17-.58.57-1.16,1.14-1.76,1.71-.12.1-.18.26-.14.41.15.84.29,1.67.44,2.51,0,.03.01.07.02.14-.12-.06-.22-.11-.32-.16-.71-.38-1.43-.75-2.15-1.12-.08-.04-.18-.04-.26,0-.74.38-1.47.76-2.2,1.15-.09.04-.17.08-.27.14Z"
}));

exports["default"] = _default;
//# sourceMappingURL=league.js.map